export const MUI_LICENSE = 'a27d102940ce27966650cb77adfa9bddTz03NjgzNixFPTE3MjkxOTcxNjEwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=';
//# sourceMappingURL=constants.js.map